import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      margin: '0 20px 20px 20px'
    }
  },
  column: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '286px',
    [theme.breakpoints.down('sm')]: {
      width: '80%',
    },
  },
  datePickerWrapper: {
    width: '257px',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '27px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
    },
  },
  cutOffField: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '120px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  cutOffTypeField: {
    width: '140px',
    marginTop: '17px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  cutOffFieldWrapper: {
    marginRight: '10px',
    [theme.breakpoints.down('sm')]: {
      marginRight: '0',
    },
  },
  divider: {
    height: '1px',
    backgroundColor: '#E5E5E5',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '15px',
    },
  },
  buttonsGroup: {
    width: '195px',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  panels: {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '15px',
    },
  },
}));
